import { connect } from 'react-redux'
import TableOfContents from './TableOfContents.jsx'
import {
    getTableOfContents,
    getTableOfContentsCurrentIndex,
    isTableOfContentsItemSelected,
} from 'redux/tableOfContents/selectors'
import { closeTableOfContents } from 'redux/tableOfContents/actions'

const mapStateToProps = state => ({
    tableOfContents: getTableOfContents(state),
    currentIndex: getTableOfContentsCurrentIndex(state),
    selected: (index) => isTableOfContentsItemSelected(state, index)
})

const mapDispatchToProps = (dispatch, getState) => ({
    close: () => {
        dispatch(closeTableOfContents())
    }
})

export const TableOfContentsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TableOfContents)
